module.exports = __webpack_public_path__ + "img/4.73b5fec1.jpg";